<template>
    <!--Debug-->
    <!--<div id="progress"></div>-->
    <div id="pixel-loader"></div>
</template>
<script>
  import MainGame from "../game/MainGame"
  import R from "../game/config/R"
  import * as $ from "jquery"
  import * as Events from "../game/Events"
  // init the main game
  MainGame.instance.init()

  Events.hub.getEventStream(Events.LOAD_COMPLETE)
    .take(1)
    .subscribe(() => {
      $('#pixel-loader').remove()
      $('body').css({'background-color': '#000'})

    })

  // Auto resize the canvas
  $(window).resize(() => {
    resizeCanvas()
  })

  $(function () {
    // initial call
    resizeCanvas()
  })


  function resizeCanvas() {
    const width = $(window).width()
    const height = $(window).height()
    console.log(`window width=${width} height=${height}`)

    if(height > width){
      // portrait mode
      scratchWithFullHeight(width, height)
    }
    else {
      // landscape mode
      scratchWithFullWidth(width, height)
    }

  }

  function scratchWithFullWidth(width, height){
    const targetRatio = height / width

    const canvasSelector = $('canvas')
    const loaderSelector = $('#pixel-loader')
    const loaderSideLength = 30

    canvasSelector.css('height', '100%')

    // the design is 4:3 (width:height)
    // calculate the origin width
    const oWidth = height / 3 * 4
    const targetWidth = height / targetRatio

    canvasSelector.css('width', `${oWidth}px`)

    if (targetWidth > oWidth) {
      // make padding
      console.log(targetWidth)
      const diff = Math.abs(targetWidth - oWidth)
      canvasSelector.css('top', '0')
      canvasSelector.css('left', `${diff / 2}px`)
    }
    else {
      canvasSelector.css('top', '0')
      canvasSelector.css('left', '0')
    }

    loaderSelector.css('top', `${height / 2 - loaderSideLength}px`)
    loaderSelector.css('left', `${targetWidth / 2}px`)

  }

  function scratchWithFullHeight(width, height){
    const targetRatio =  width / height

    const canvasSelector = $('canvas')
    const loaderSelector = $('#pixel-loader')
    const loaderSideLength = 30

    canvasSelector.css('width', '100%')

    // the design is 4:3 (width:height)
    // calculate the origin width
    const oHeight = width / 4 * 3
    const targetHeight = width / targetRatio

    canvasSelector.css('height', `${oHeight}px`)

    if (targetHeight > oHeight) {
      // make padding
      console.log(targetHeight)
      const diff = Math.abs(targetHeight - oHeight)
      canvasSelector.css('left', '0')
      canvasSelector.css('top', `${diff / 2}px`)
    }
    else {
      canvasSelector.css('left', '0')
      canvasSelector.css('top', '0')
    }


    loaderSelector.css('top', `${targetHeight / 2 - loaderSideLength}px`)
    loaderSelector.css('left', `${width / 2}px`)

  }

  export default {
    name: 'hello',
    data () {
      return {}
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
    body canvas {
        position: fixed;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0
    }

    body {
        background-color: #fff
    }

    #progress {
        position: fixed;
        width: 100%;
        text-align: center;
        top: 45%;
        font-size: 3em;
        color: #eaeaea
    }

    #pixel-loader {
        width: 10px;
        height: 10px;
        top: -100px;
        left: -100px;
        background: #f35626;
        color: #f35626;
        position: absolute;
        box-shadow: 15px 15px 0 0, -15px -15px 0 0, 15px -15px 0 0, -15px 15px 0 0, 0 15px 0 0, 15px 0 0 0, -15px 0 0 0, 0 -15px 0 0;
        -webkit-animation: anim 2s linear infinite;
        animation: anim 2s linear infinite
    }

    @-webkit-keyframes anim {
        0% {
            -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
            -webkit-filter: hue-rotate(0deg)
        }
        50% {
            box-shadow: 20px 20px 0 0, -20px -20px 0 0, 20px -20px 0 0, -20px 20px 0 0, 0 10px 0 0, 10px 0 0 0, -10px 0 0 0, 0 -10px 0 0
        }
        75% {
            box-shadow: 20px 20px 0 0, -20px -20px 0 0, 20px -20px 0 0, -20px 20px 0 0, 0 10px 0 0, 10px 0 0 0, -10px 0 0 0, 0 -10px 0 0
        }
        to {
            -webkit-transform: rotate(1turn);
            transform: rotate(1turn);
            -webkit-filter: hue-rotate(1turn)
        }
    }

    @keyframes anim {
        0% {
            -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
            -webkit-filter: hue-rotate(0deg)
        }
        50% {
            box-shadow: 20px 20px 0 0, -20px -20px 0 0, 20px -20px 0 0, -20px 20px 0 0, 0 10px 0 0, 10px 0 0 0, -10px 0 0 0, 0 -10px 0 0
        }
        75% {
            box-shadow: 20px 20px 0 0, -20px -20px 0 0, 20px -20px 0 0, -20px 20px 0 0, 0 10px 0 0, 10px 0 0 0, -10px 0 0 0, 0 -10px 0 0
        }
        to {
            -webkit-transform: rotate(1turn);
            transform: rotate(1turn);
            -webkit-filter: hue-rotate(1turn)
        }
    }
</style>



// WEBPACK FOOTER //
// Game.vue?e3f5f3e6